import { io } from 'socket.io-client';

// Replace 'http://localhost:3001' with your backend URL if different
const socketModule = io(process.env.REACT_APP_SOCKET_URL,{ 
    transports: ['websocket', 'polling'],
    debug: true
  });

export default socketModule;
